import React from "react";
import EditIcon from "@mui/icons-material/Edit";

import { AllPagination, CommonFilters, TitleHeader } from "../../../components";
import useOrderListUtils from "./orderUtils";
import CommonTable from "../../../common/commonTable";
import { useNavigate } from "react-router-dom";
import DataNotFound from "../../../common/DataNotFound/DataNotFound";
import Table from "react-bootstrap/Table";
import { IconEyes } from "../../../icon/icons";
import { TableShimmer } from "../../../common/Shimmer";
import { ucfirst } from "../../../utils/customFn";

const OrderList = () => {
  const navigate = useNavigate();

  const {
    listData,
    loading,
    currentPage,
    limit,
    fetchOrderData,
    handleSearch,
    handleFilter,
    handlePageChange,
    services,
  } = useOrderListUtils();


  const getStatusClass = (status) => {
    switch (status) {
      case "Pending":
        return "pending";
      case "Accepted":
        return "success"; 
      case "Collecting":
        return "upcoming";
      case "Delivering":
        return "delivery-pending";
      case "Completed":
        return "completed";
      case "Cancelled":
        return "rejected";
      default:
        return "pending"; 
    }
  };



  return (
    <>
      <TitleHeader heading="Welcome to Jayeek!  " buttonText="+ Add New" />
      <div className="page-card-bg table-data-new">
        <CommonFilters
          heading="Order List"
          handleSearch={handleSearch}
          handleFilter={handleFilter}
          placeholderText = "Search By Id"
          filterFields={[
            {
              name: "status",
              label: "status",
              type: "autocomplete",
              options: [
                { title: "Pending", id: "pending" },
                { title: "Accepted", id: "accepted" },
                { title: "Collecting", id: "pickup_initiated" },
                { title: "Delivering", id: "pickup_confirmed" },
                { title: "Completed", id: "delivered" },
                { title: "Cancelled", id: "cancelled" },
              ],
              placeholder: "Select status",
            },

            {
              name: "services",
              label: "services",
              type: "autocomplete",
              options: services.map((service) => ({
                id: service.id,
                title: service.service_descriptions.title,
              })),
              placeholder: "Select services",
            },
          ]}
        />

        <div className="table-data-main">
          {loading ? (
            <TableShimmer />
          ) : (
            <Table responsive>
              <thead>
                <tr>
                  
                  <th>Order Id</th>
                  <th>Shipper</th>
                  <th>Service</th>
                  <th>Quantity</th>
                  
                  <th>pickup location</th>
                  <th>dropoff location </th>
                  <th>Assigned driver</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {listData?.docs?.length > 0 ? (
                  listData?.docs?.map((item, index) => {
                    return (
                      <tr key={item.id}>
                       

                        <td>
                          <div className="user-info">
                            <p>#{item?.id}</p>
                          </div>
                        </td>

                        <td>
                          <div className="user-info">
                            <p>
                              {item?.user?.name || "N/A"}
                            </p>
                          </div>
                        </td>


                        <td>
                          <div className="user-info">
                            <p>
                              {item?.getService?.service_descriptions?.title ||
                                "N/A"}
                            </p>
                          </div>
                        </td>

                        <td>
                          <div className="user-info">
                            <p>{item?.quantity || "N/A"}</p>
                          </div>
                        </td>

                        

                        <td>
                          <div className="user-info">
                            <p>
                              {(item?.pickup_location?.length > 16)
                                ? item.pickup_location.slice(0, 16) + '...'
                                : item.pickup_location || 'N/A'}
                            </p>
                          </div>
                        </td>

                        <td>
                          <div className="user-info">
                            <p>
                              {(item?.dropoff_location?.length > 16)
                                ? item.dropoff_location.slice(0, 16) + '...'
                                : item.dropoff_location || 'N/A'}
                            </p>
                          </div>
                        </td>
                    

                        <td>
                          <div className="user-info">
                            <p>{item?.getDriver?.name || "N/A"}</p>
                          </div>
                        </td>

                        <td>
                          <div className="user-info">
                          <span className={getStatusClass(item.status)}>{ucfirst(item?.status) || "N/A"}</span>
                          </div>
                        </td>

                        <td>
                          <div className="btn-dis-new">
                            <button
                              className="btn-viwe-icon"
                              onClick={() =>
                                navigate(`/order/details/${item.id}`)
                              }
                            >
                              <IconEyes />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="9">
                      <DataNotFound message="No records found" />
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}

      {listData?.pages > 1 && (
          <AllPagination
            totalPages={listData?.pages}
            currentPage={currentPage}
            totalRecords={listData?.pages}
            onPageChange={handlePageChange}
            limit={limit}
          />
        )}
        </div>
      </div>
    </>
  );
};

export default OrderList;
